import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationSE from './locales/se/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  sv: {
    translation: translationSE,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'sv',
  debug: true,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
